<template>
  <v-card
    class="pa-6 tally-form-card"
    elevation="0"
  >
    <v-card-title class="text-title">
      2. Provide Your Integration Details
    </v-card-title>
    <v-card-text class="pa-0 mt-7">
      <p>Click below to submit your integration details:</p>
      <DpplAutoSizedButton
        class="mt-8"
        width="277"
        :href="formUrl"
        target="_blank"
        rel="noopener noreferrer"
      >
        Open Integration Form
      </DpplAutoSizedButton>
    </v-card-text>
  </v-card>
</template>

<script>
import DpplAutoSizedButton from '@/components/datapeople/DpplAutoSizedButton.vue';

export default {
  name: 'TallyFormCard',
  components: {
    DpplAutoSizedButton,
  },
  props: {
    formUrl: { type: String, required: true },
  },
};
</script>

<style scoped lang="less">
.tally-form-card {
  width: calc(50% - 6px);
  height: 250px;
}
</style>
